<div
    class="logo"
    [ngClass]="{ small: small }"></div>
